import React from 'react';
import { Link, Typography } from '@mui/material';
import { OpenInNew as OpenInNewIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { employeePortalUrl } from '../utils/employeePortal';

interface EmployeeCatalogLinkProps {
  /** Márgenes/ajustes del sitio donde se inserta (los tres diálogos difieren). */
  sx?: object;
}

/**
 * Invitación a consultar el catálogo ANTES de elegir en el selector.
 *
 * Los tres diálogos de contratación (portal cliente, portal partner y admin)
 * solo enseñan el NOMBRE del empleado: quien contrata no puede saber desde ahí
 * qué hace cada uno, qué casos de uso cubre ni qué necesita para trabajar. El
 * enlace abre el catálogo público en una pestaña nueva para no perder lo que ya
 * lleva escrito en el diálogo.
 */
const EmployeeCatalogLink: React.FC<EmployeeCatalogLinkProps> = ({ sx }) => {
  const { t } = useTranslation();
  return (
    <Typography variant="body2" color="text.secondary" sx={{ mb: 2, ...sx }}>
      {t(
        'employeeCatalog.hint',
        '¿No sabes cuál elegir? Mira qué hace cada empleado, sus casos de uso y lo que necesita para trabajar:'
      )}{' '}
      <Link
        href={employeePortalUrl()}
        target="_blank"
        rel="noopener noreferrer"
        sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, fontWeight: 600 }}
      >
        {t('employeeCatalog.link', 'Ver el catálogo de empleados')}
        <OpenInNewIcon fontSize="inherit" />
      </Link>
    </Typography>
  );
};

export default EmployeeCatalogLink;
